<template>
  <v-list
    dense
    style="padding: 2px 0 2px 0"
    :style="getContainerStyle()"
    v-show="showAndHideBasedOnPermission(item, 1)"
  >
    <v-list-group
      v-if="item.items && !item.ignoreItems"
      :key="item.text"
      v-model="item.expanded"
      :prepend-icon="getPrependIcon(item)"
      :append-icon="getAppendIcon(item)"
    >
      <template #activator>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t(item.key) }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <ArchNavMenu
        :item="child"
        v-for="(child, i) in item.items"
        :key="`menu-${i}`"
        :component="component"
        :visible="visible"
        :loading="loading"
        @update:component="(v) => $emit('update:component',v)"
        @update:visible="(v) => $emit('update:visible',v)"
        @update:loading="(v) => $emit('update:loading',v)"
      />
    </v-list-group>
    <v-list-item
      v-else
      @click="onClick"
      :key="item.key"
      link
      :to="!item.isCustomMenu ? $parseURL(item.link): undefined"
      v-show="showAndHideBasedOnPermission(item.link, 2)"
    >
      <v-list-item-action>
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title v-if="$t(item.key).length < 18">
          {{ $t(item.key) }}
        </v-list-item-title>
        <v-tooltip
          v-else
          bottom
          open-delay="200"
          transition="v-slide-y-transition"
        >
          <template #activator="{ on }">
            <v-list-item-title v-on="on">
              {{ $t(item.key) }}
            </v-list-item-title>
          </template>
          <span>{{ $t(item.key) }}</span>
        </v-tooltip>

      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import PermissionHelper from "@/permissions/PermissionHelper";
import {PermissionEnum} from "@/permissions/PermissionEnum";

export default {
  name: "ArchNavMenu",
  props: {
    item: {},
    component: "",
    visible: false,
    loading: ""
  },
  computed: {
    icon() {
      return this.$i(this.item.key.slice(this.item.key.indexOf(".")+1));
    }
  },
  methods: {
    getContainerStyle(i) {
      let level = this.item.level || 1;
      // if(level>1){
      //   return {}
      // }
      return {
        marginLeft: ((level-1) * 15)+"px",
        //marginLeft:"5px",
        marginRight: "5px"
      };
    },
    getPrependIcon(item) {
      return item.expanded ? "mdi-chevron-up" : "mdi-chevron-down";
      if (item.level == 1) {
        return item.expanded ? "mdi-chevron-up" : "mdi-chevron-down";
      }
      return "";
    },
    getAppendIcon(item) {
      return "";
      if (item.level == 2) {
        return item.expanded ? "mdi-minus" : "mdi-plus";
      }
      return "";
    },
    close() {
      this.$emit("update:visible", false);
    },
    onClick() {
      if(this.item.isCustomMenu) {
        this.$emit("update:component", this.item.component);
        setTimeout(() => {
          this.$emit("update:visible", true);
        }, 200);
      }
    },
    showAndHideBasedOnPermission(item, type) {
      if(PermissionHelper.canAccess({type: type == 1 ? PermissionEnum.MENU : PermissionEnum.MENU_CHILD, item: item})){
        return true;
      }
      return false;
    }
  },
};
</script>

<style scoped>
</style>
